import { useTranslation } from 'next-i18next';
import { useLocale } from '@/hooks';
import { ArrowRightIcon } from '@/icons';
import { Button } from '@/ui_v3';
import { handleContactSalesClick } from '../utils';
import { ZepQuizBizLogo } from './ZepQuizBizLogo';
export const BizIntroduction = () => {
  return <section className="flex flex-col items-center pb-xl pt-2xl min-[751px]:pb-2xl min-[751px]:pt-3xl" data-sentry-component="BizIntroduction" data-sentry-source-file="BizIntroduction.tsx">
      <Title data-sentry-element="Title" data-sentry-source-file="BizIntroduction.tsx" />
      <Buttons data-sentry-element="Buttons" data-sentry-source-file="BizIntroduction.tsx" />
      <CompanyLogos data-sentry-element="CompanyLogos" data-sentry-source-file="BizIntroduction.tsx" />
    </section>;
};
const Title = () => {
  const {
    t
  } = useTranslation(['bizLanding']);
  return <div className="flex flex-wrap items-center justify-center gap-lg text-center" data-sentry-component="Title" data-sentry-source-file="BizIntroduction.tsx">
      <h2 className="text-center text-heading-xl-extrabold text-default min-[751px]:text-display-sm-extrabold">
        {t('biz-landing.eduTech.title_new')}
      </h2>
      <ZepQuizBizLogo className="relative bottom-[2px]" data-sentry-element="ZepQuizBizLogo" data-sentry-source-file="BizIntroduction.tsx" />
    </div>;
};
const Buttons = () => {
  const {
    t
  } = useTranslation(['bizLanding']);
  const {
    locale
  } = useLocale();
  return <div className="mb-2xl mt-[24px] flex flex-col items-center gap-sm min-[751px]:mb-4xl min-[751px]:flex-row min-[751px]:gap-2xs" data-sentry-component="Buttons" data-sentry-source-file="BizIntroduction.tsx">
      <Button variant="contained" intent="gradient" size="lg" rounded="default" onClick={() => handleContactSalesClick(locale)} data-sentry-element="Button" data-sentry-source-file="BizIntroduction.tsx">
        {t('biz-landing.introduction.button')}
        <ArrowRightIcon size="md" data-sentry-element="ArrowRightIcon" data-sentry-source-file="BizIntroduction.tsx" />
      </Button>
    </div>;
};
const COMPANY_LOGOS = ['/assets/biz-landing/company/samsung.webp', '/assets/biz-landing/company/naver.webp', '/assets/biz-landing/company/hyundai.webp', '/assets/biz-landing/company/hanwha.webp', '/assets/biz-landing/company/lg.webp', '/assets/biz-landing/company/coupang.webp'];
const CompanyLogos = () => {
  return <div className="flex flex-wrap justify-center gap-lg" data-sentry-component="CompanyLogos" data-sentry-source-file="BizIntroduction.tsx">
      {COMPANY_LOGOS.map((logo, index) => <img key={logo} src={logo} alt={`Company logo ${index}`} className="w-[180px]" />)}
    </div>;
};